import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(() => localStorage.getItem('auth'));
  const [username, setUsername] = useState(() => localStorage.getItem('username'));
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem('auth'));

  useEffect(() => {
    if (auth) {
      localStorage.setItem('auth', auth);
      setIsLoggedIn(true);
    } else {
      localStorage.removeItem('auth');
      localStorage.removeItem('username');
      setIsLoggedIn(false);
      setUsername(null);
    }
  }, [auth]);

  const setCredentials = (username, password) => {
    const encodedCredentials = btoa(`${username}:${password}`);
    setAuth(encodedCredentials);
    setUsername(username);
    localStorage.setItem('username', username);
  };

  const logout = () => {
    setAuth(null);
    setUsername(null);
  };

  return (
      <AuthContext.Provider value={{ auth, isLoggedIn, username, setCredentials, logout }}>
        {children}
      </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);